/**
 * @Date: 2025-02-17 09:57:57
 * @FilePath: /actdianyuan/src/router/router2026.js
 * @Author: zwy
 * @Description:
 */

const Act2026 = [
  // 英飞凌
  {
    path: "/infineon202602",
    name: "infineon202602",
    component: (resolve) =>
      require(["@/act2026/infineon202602/index.vue"], resolve),
    meta: {
      title: "驱动未来,高效节能新纪元",
    },
  },
  {
    path: "/keysight260303jc/index",
    name: "keysight260303jc",
    component: (resolve) =>
      require(["@/act2026/keysight260303jc/index.vue"], resolve),
    meta: {
      title: "",
    },
  },
  {
    path: "/keysight261023/index",
    name: "keysight261023",
    component: (resolve) =>
      require(["@/act2026/keysight261023/index.vue"], resolve),
    meta: {
      title: "是德小视频精测活动",
    },
  },
  {
    path: "/zhirong260414/index",
    name: "zhirong260414",
    component: (resolve) =>
      require(["@/act2026/zhirong260414/index.vue"], resolve),
    meta: {
      title: "",
    },
  },
  {
    path: "/fangan/index/:page_identify?",
    name: "fangan",
    component: (resolve) =>
      require(["@/act2026/fangan/index.vue"], resolve),
    meta: {
      title: "方案大会参展手册",
    },
  },
  {
    path: "/keysight260520bq",
    name: "keysight260520bq",
    component: (resolve) =>
      require(["@/act2026/keysight260520bq/index.vue"], resolve),
    meta: {
      title: "贝奇",
    },
  },
  {
    path: "/munihei260610",
    name: "munihei260610",
    component: (resolve) =>
      require(["@/act2026/munihei260610/index.vue"], resolve),
    meta: {
      title: "2026年慕尼黑会议",
    },
  },
  {
    path: "/onsemi260610",
    name: "onsemi260610",
    component: (resolve) =>
      require(["@/act2026/onsemi260610/index.vue"], resolve),
    meta: {
      title: "安森美创新工坊，打造你的智能未来",
    },
  },
  {
    path: "/mps260713",
    name: "mps260713",
    component: (resolve) =>
      require(["@/act2026/mps260713/index.vue"], resolve),
    meta: {
      title: "储能革新·主动均衡",
    },
  },
  {
    path: "/mps2609",
    name: "mps2609",
    component: (resolve) =>
      require(["@/act2026/mps2609/index.vue"], resolve),
    meta: {
      title: "“看见”磁场:磁传感技术从原理到实战",
    },
  },
];

export default Act2026;
